import { render, staticRenderFns } from "./FacturaPage.vue?vue&type=template&id=417728ac"
import script from "./FacturaPage.js?vue&type=script&lang=js&external"
export * from "./FacturaPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports